module.exports = __webpack_public_path__ + "img/ic_nav_playlists.861d48e5.svg";